export const intersec = (left: Array<any>, right: Array<any>, attr: string) => {
  if (!left || !right) {
    return null
  }
  return left.filter((leftItem) => right.find((rightItem) => rightItem[attr] === leftItem[attr]))
}

export const getSafePrice = (amount: number) => Math.round(amount * 100) / 100
